<header class="header">
  <div class="header__inner">
    <a class="header__logo" routerLink="/accueil">
      <img
        [src]="logoUrl"
        alt="Saarvie"
        class="header__logo-img"
        (error)="onLogoError($event)" />
      <span class="header__brand">
        <strong>SAARVIE</strong>
      </span>
    </a>

    <nav class="header__nav" [class.header__nav--open]="menuOpen" aria-label="Navigation principale">
      <a
        *ngFor="let link of navLinks"
        class="header__link"
        [class.header__link--active]="isActive(link)"
        [routerLink]="link.route"
        [fragment]="link.fragment"
        (click)="onNavClick(link)">
        {{ link.label }}
      </a>
    </nav>

    <div class="header__actions">
      <button
        type="button"
        class="header__notifications"
        aria-label="Notifications"
        [matBadge]="notificationBadgeLabel()"
        [matBadgeHidden]="notificationCount === 0"
        matBadgeColor="warn"
        matBadgeSize="small"
        (click)="openNotifications()">
        <mat-icon aria-hidden="true">notifications_none</mat-icon>
      </button>

      <ng-container *ngIf="isAuthenticated; else guestActions">
        <a class="header__profile" routerLink="/profil" (click)="menuOpen = false">
          <mat-icon aria-hidden="true">account_circle</mat-icon>
          <span>{{ displayName }}</span>
        </a>
        <button class="header__auth-btn header__auth-btn--outline" type="button" (click)="logout()">
          Déconnexion
        </button>
      </ng-container>

      <ng-template #guestActions>
        <a class="header__auth-btn" routerLink="/se-connecter" (click)="menuOpen = false">
          Se connecter
        </a>
      </ng-template>
    </div>

    <button
      class="header__burger"
      type="button"
      aria-label="Menu"
      [attr.aria-expanded]="menuOpen"
      (click)="toggleMenu()">
      <mat-icon>{{ menuOpen ? 'close' : 'menu' }}</mat-icon>
    </button>
  </div>
</header>
